import React from 'react';
import {Image, ImageBackground, Platform, SafeAreaView, TouchableOpacity, View} from 'react-native';
import {connect} from 'react-redux';
import {DrawerActions} from '@react-navigation/native';
import IAppState from "../Models/App/IAppState";
import {EPage} from "../Models/EPage";
import AppText from "./AppText";
import HideableView from "./HideableView";
import {WebMenuContext} from "./WebMenuContext";

interface IProps {
    pageId: EPage;
    navigation: any;
}

class AppHeader extends React.Component<IProps> {
    static contextType = WebMenuContext;
    declare context: React.ContextType<typeof WebMenuContext>;

    renderTitle() {
        let word1 = '';
        let word2 = '';
        if (this.props.pageId == EPage.login) {
            word1 = 'כניסה';
            word2 = 'למערכת';
        }
        if (this.props.pageId == EPage.clients) {
            word1 = 'ניהול';
            word2 = 'לקוחות';
        }
        if (this.props.pageId == EPage.courier) {
            word1 = 'ניהול';
            word2 = 'שליחים';
        }
        if (this.props.pageId == EPage.openOrder) {
            word1 = 'פתיחת';
            word2 = 'הזמנה';
        }
        if (this.props.pageId == EPage.orderHistory) {
            word1 = 'הסטוריית';
            word2 = 'הזמנות';
        }
        if (this.props.pageId == EPage.orders) {
            word1 = 'טיפול';
            word2 = 'בהזמנות';
        }
        return (
            <View style={{justifyContent: 'center', alignItems: 'center', flexDirection: 'row'}}>
                <AppText style={{fontSize: 24, fontWeight: '500'}}>{word1}</AppText>
                <AppText style={{marginLeft: 5, fontSize: 24, color: '#019FB2', fontWeight: '500'}}>{word2}</AppText>
            </View>
        );
    }

    isMenuHidden() {
        return this.props.pageId == EPage.login;
    }

    openMenu() {
        if (Platform.OS === 'web') {
            this.context.open();
            return;
        }
        this.props.navigation.dispatch(DrawerActions.openDrawer());
    }

    render() {
        return (
            <SafeAreaView style={{backgroundColor: '#f1f1f1', width: '100%'}}>
                <ImageBackground source={require('../assets/headerImg.png')} style={{width: '100%', height: 50}}>
                    <View style={{width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.75)', flexDirection: 'row', alignItems: 'flex-end', paddingBottom: 5}}>
                        <View style={{flex: 0.2, justifyContent: 'center', alignItems: 'center'}}>
                            <HideableView hidden={this.isMenuHidden()}>
                                <TouchableOpacity onPress={() => this.openMenu()}>
                                    <Image source={require('../assets/menu-icon.png')} style={{width: 30, height: 25, marginBottom: 5}}/>
                                </TouchableOpacity>
                            </HideableView>
                        </View>
                        <View style={{flex: 0.6, justifyContent: 'center', alignItems: 'center', flexDirection: 'row'}}>
                            {this.renderTitle()}
                        </View>
                        <View style={{flex: 0.2}}/>
                    </View>
                </ImageBackground>
            </SafeAreaView>
        );
    }
}

const mapStateToProps = (_state: IAppState) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
